import styles from "./styles.module.scss";
import { ConditionalRendererProps } from "../../utils/types";
import { Fragment, PropsWithChildren, ReactElement } from "react";

export function LegendCards({ sideDetails }: any) {
  return (
    <div className={styles.cardsContainer}>
      <div className={styles.legendCard}>
        <div className={styles.icon}>
          <img
            src="./assets/icons/totalProcessedSwings.svg"
            alt="Icon"
            style={{ width: "40px" }}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>Total Processed Swing</div>
          <div className={styles.value} style={{ color: "#0469B4" }}>
            {sideDetails?.total_swings ?? "--"}
          </div>
        </div>
      </div>

      <div className={styles.legendCard}>
        <div className={styles.icon}>
          <img
            src="./assets/icons/avg.svg"
            alt="Icon"
            className={styles.iconStyle}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>Avg. Processing Time</div>
          <div className={styles.value} style={{ color: "#F4BD00" }}>
            {sideDetails?.avg_processing_time?.toFixed(1) ?? "--"} seconds
          </div>
        </div>
      </div>

      <div className={styles.legendCard}>
        <div className={styles.icon}>
          <img
            src="./assets/icons/max.svg"
            alt="Icon"
            className={styles.iconStyle}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>Max. Processing Time</div>
          <div className={styles.value} style={{ color: "#667085" }}>
            {sideDetails?.max_processing_time?.toFixed(1) ?? "--"} seconds
          </div>
        </div>
      </div>

      <div className={styles.legendCard}>
        <div className={styles.icon}>
          <img
            src="./assets/icons/min.svg"
            alt="Icon"
            className={styles.iconStyle}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>Min. Processing Time</div>
          <div className={styles.value} style={{ color: "#00D1FF" }}>
            {sideDetails?.min_processing_time?.toFixed(1) ?? "--"} seconds
          </div>
        </div>
      </div>

      <div className={styles.legendCard}>
        <div className={styles.icon}>
          <img
            src="./assets/icons/success.svg"
            alt="Icon"
            className={styles.iconStyle}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>Success Rate (%)</div>
          <div className={styles.value} style={{ color: "#16A665" }}>
            {sideDetails?.success_percentage ?? "--"} %
          </div>
        </div>
      </div>
      <div className={styles.legendCard}>
        <div className={styles.icon}>
          <img
            src="./assets/icons/fail.svg"
            alt="Icon"
            className={styles.iconStyle}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}> Failure Rate (%)</div>
          <div className={styles.value} style={{ color: "#F63E3E" }}>
            {sideDetails?.failure_percentage ?? "--"} %
          </div>
        </div>
      </div>
    </div>
  );
}
